import React, { useState } from 'react';
import { PDFExport } from '@progress/kendo-react-pdf';

const MessageTable = React.forwardRef(({ data, sortData, setData }, ref) => {
    const [order, setOrder] = useState('asc');

    const onSort = (col) => {
        if (order === 'asc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] > b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('desc');
        }
        if (order === 'desc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] < b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('asc');
        }
    };

    return (
        <div className="flex flex-col w-full">
            <div className="overflow-x-auto">
                <div className="py-2 inline-block min-w-full">
                    <div className="overflow-hidden">
                        <PDFExport paperSize="A4" fileName="dashboard" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                            <table className="min-w-full" id='table-to-xls'>
                                <thead className="bg-white border-b">
                                    <tr>
                                        <th scope="col" className="table_head" onClick={() => onSort('name')}>
                                            Message From<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('subject')}>
                                            Subject<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('desc')}>
                                            Description<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('date')}>
                                            Date<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {data.length > 0 ? (data.map((body, index) => <tr className="bg-white border-b animation hover:bg-gray-100" key={index}>
                                        <td className="table_body">
                                            {body.name}
                                        </td>
                                        <td className="table_body">
                                            {body.subject}
                                        </td>
                                        <td className="table_body">
                                            {body.desc}
                                        </td>
                                        <td className="table_body">
                                            {body.date}
                                        </td>
                                    </tr>)) : <td colSpan="100%" className='py-3 text-sm text-gray-800 text-center border-b'>No Data Available</td>}

                                </tbody>
                            </table>
                        </PDFExport>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default MessageTable;